export const ModalityIcon = ({ type }: { type: string }) => {
	switch (type) {
		case "text":
			return (
				<svg viewBox="0 0 24 24" className="modality-icon">
					<title>Text</title>
					<path d="M4 7V4h16v3M9 20h6M12 4v16" />
				</svg>
			);
		case "image":
			return (
				<svg viewBox="0 0 24 24" className="modality-icon">
					<title>Image</title>
					<rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
					<circle cx="8.5" cy="8.5" r="1.5" />
					<polyline points="21 15 16 10 5 21" />
				</svg>
			);
		case "audio":
			return (
				<svg viewBox="0 0 24 24" className="modality-icon">
					<title>Audio</title>
					<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
					<path d="M19 10v2a7 7 0 0 1-14 0v-2" />
				</svg>
			);
		case "video":
			return (
				<svg viewBox="0 0 24 24" className="modality-icon">
					<title>Video</title>
					<path d="m22 8-6 4 6 4V8Z" />
					<rect x="2" y="6" width="14" height="12" rx="2" ry="2" />
				</svg>
			);
		case "pdf":
			return (
				<svg viewBox="0 0 24 24" className="modality-icon">
					<title>PDF</title>
					<path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
					<polyline points="14 2 14 8 20 8" />
				</svg>
			);
		default:
			return null;
	}
};
